module.exports = __webpack_public_path__ + "img/LSBBTableauDeBord.3a2ccb92.jpg";